const logRoutes = [
  {
    path: 'log/hardware',
    name: 'HardwareLog',
    component: () => import('@/layouts/BlankLayout'),
    meta: {
      title: '硬件日志',
      icon: 'hardware',
      requireApiPermission: ['base.hardware_log.view']
    },
    children: [
      {
        path: 'network-device',
        name: 'NetworkDeviceLog',
        meta: {
          title: '网络设备',
          requireApiPermission: ['base.hardware_log.view']
        },
        component: () => import('@/views/log-center/NetworkDeviceLog.vue')
      },
      {
        path: 'security',
        name: 'SecurityLog',
        meta: {
          title: '安全设备',
          requireApiPermission: ['base.hardware_log.view']
        },
        component: () => import('@/views/log-center/SecurityLog.vue')
      },
      {
        path: 'server',
        name: 'ServerLog',
        meta: {
          title: '服务器',
          requireApiPermission: ['base.hardware_log.view']
        },
        component: () => import('@/views/log-center/ServerLog.vue')
      }
    ]
  },
  {
    path: 'log/os',
    name: 'OSLog',
    component: () => import('@/layouts/BlankLayout'),
    meta: {
      title: '操作系统日志',
      icon: 'os',
      requireApiPermission: ['base.os_log.view']
    },
    children: [
      {
        path: 'windows',
        name: 'WindowsLog',
        meta: {
          title: 'Windows',
          requireApiPermission: ['base.os_log.view']
        },
        component: () => import('@/views/log-center/WindowsLog.vue')
      },
      {
        path: 'linux',
        name: 'LinuxLog',
        meta: {
          title: 'Linux',
          requireApiPermission: ['base.os_log.view']
        },
        component: () => import('@/views/log-center/LinuxLog.vue')
      }
    ]
  },
  {
    path: 'log/middleware',
    name: 'MiddlewareLog',
    component: () => import('@/layouts/BlankLayout'),
    meta: {
      title: '中间件日志',
      icon: 'middleware',
      requireApiPermission: ['base.middleware_log.view']
    },
    children: [
      {
        path: 'nginx',
        name: 'NginxLog',
        meta: {
          title: 'THS',
          requireApiPermission: ['base.middleware_log.view']
        },
        component: () => import('@/views/log-center/NginxLog')
      },
      {
        path: 'tomcat',
        name: 'TomcatLog',
        meta: {
          title: 'TongWeb',
          requireApiPermission: ['base.middleware_log.view']
        },
        component: () => import('@/views/log-center/TomcatLog')
      }
    ]
  },
  {
    path: 'log/database',
    name: 'DatabaseLog',
    component: () => import('@/layouts/BlankLayout'),
    meta: {
      title: '数据库日志',
      icon: 'database',
      requireApiPermission: ['base.database_log.view']
    },
    children: [
      {
        path: 'dameng',
        name: 'DamengLog',
        meta: {
          title: '达梦审计日志',
          requireApiPermission: ['base.database_log.view']
        },
        component: () => import('@/views/log-center/DamengLog')
      }
    ]
  },
  {
    path: 'log/service',
    name: 'ServiceLog',
    component: () => import('@/layouts/BlankLayout'),
    meta: {
      title: '业务日志',
      icon: 'service',
      requireApiPermission: ['service.service_log.view']
    },
    children: [
      {
        path: 'key',
        name: 'ServiceKeyLog',
        meta: {
          title: '关键日志',
          requireApiPermission: ['service.service_log.view']
        },
        component: () => import('@/views/log-center/ServiceKeyLog')
      },
      {
        path: 'statistic',
        name: 'ServiceStatisticLog',
        meta: {
          title: '统计日志',
          requireApiPermission: ['service.service_log.view']
        },
        component: () => import('@/views/log-center/ServiceStisticsLog')
      },
      {
        path: '3rd-interface',
        name: 'ServiceInterfaceLog',
        meta: {
          title: '第三方接口日志',
          requireApiPermission: ['service.service_log.view']
        },
        component: () => import('@/views/log-center/ServiceInterfaceLog')
      }
    ]
  },
  {
    path: 'log/data-exchange',
    name: 'DataExchangeLog',
    meta: {
      title: '数据交换日志',
      icon: 'data_exchange',
      requireApiPermission: ['service.data_exchange_log.view']
    },
    component: () => import('@/views/log-center/DataExchangeLog')
  }
]
export default logRoutes
